import React from 'react';
import processList from '../../data/feature/processList';
import Section from '../common/Section';
import Process from './Process';
import SectionHeader from './SectionHeader';
import { isIterableArray } from '../../helpers/utils';

const Processes = () => (
  <Section className="pt-3">
    <SectionHeader
      title="Bekhzod Akhrorov"
      subtitle="You can find briefly about working experience and education background"
    />
    <SectionHeader subtitle="- WORK EXPERIENCE -" />
    {processList.work.map((process, index) => (
      <Process key={index} {...process} />
    ))}
    <SectionHeader subtitle="- EDUCATION AND TRAINING -" />
    {processList.education.map((process, index) => (
      <Process key={index} {...process} />
    ))}
  </Section>
);

export default Processes;
